"use client";
import { useState, useEffect } from "react";
import StoreHeader from "@/app/components/common/store/StoreHeader";
import StoreTabs from "@/app/components/common/store/StoreTabs";
import StoreDescription from "@/app/components/common/store/StoreDescription";
import useStore from "@/app/lib/features/store/store.hook";
import { useStoreSectionBuilder } from "@/app/hooks/useStoreSectionBuilder";
import { StoreSellerData } from "@/app/lib/features/store/store.types";
import { trackSellerView } from "@/app/lib/tracking/interactions";

interface StorePageClientProps {
  initialData: StoreSellerData;
}

const StorePageClient = ({ initialData }: StorePageClientProps) => {
  const [searchValue, setSearchValue] = useState("");

  const {
    seller,
    sections,
    tabs,
    search,
    currentSlug,
    fetchStoreFullData,
    reset,
  } = useStore();

  useEffect(() => {
    document.body.classList.add("hide-main-header");
    return () => document.body.classList.remove("hide-main-header");
  }, []);

  // Reset unmount'ta DEĞİL, mount'ta ve yalnızca mağaza değiştiyse — sekmeler
  // arası geçişte auth'lu seller verisi korunsun (bkz. StoreTabPageClient).
  // Client refetch is_followed gibi auth-bağımlı alanları tazeler; pending
  // sırasında seller/sections TEMİZLENMEZ → initialData görünür kalır.
  useEffect(() => {
    const slug = initialData.seller.slug;
    if (currentSlug && currentSlug !== slug) {
      reset();
    }
    fetchStoreFullData(slug);
    if (initialData.seller.id) trackSellerView(initialData.seller.id);
  }, [initialData.seller.slug]); // eslint-disable-line react-hooks/exhaustive-deps

  // SSR fallback: Redux henüz boşken initialData'yı DOĞRUDAN render et — skeleton
  // kapısı YOK. getServerStoreSeller seller+tabs+search+sections'ın hepsini
  // döndürdüğünden mağaza içeriği SSR HTML'de gelir (SEO + LCP + boş ekran yok).
  const activeSeller = seller ?? initialData.seller;
  const activeTabs = tabs.length ? tabs : initialData.tabs;
  const activeSections = sections.length ? sections : initialData.sections;
  const activeSearch = search ?? initialData.search;

  const sectionComponents = useStoreSectionBuilder(activeSections, activeSeller.slug);

  const homeTabKey = activeTabs[0]?.key ?? "home";

  return (
    <div className="min-h-screen bg-gray-50">
      <StoreHeader seller={activeSeller} />
      <StoreTabs
        storeName={activeSeller.name}
        searchPlaceholder={activeSearch.placeholder}
        tabs={activeTabs}
        sellerSlug={activeSeller.slug}
        activeTabKey={homeTabKey}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
      />
      <div className="container-main py-6">
        <div className="space-y-8">
          {sectionComponents.map((item) => item.component)}
          {activeSeller.info && (
            <StoreDescription
              storeName={activeSeller.name}
              description={activeSeller.info}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StorePageClient;
